import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { GET_GROUPS_PATH } from 'src/services/api/groups/constants';
import type { IGetGroupsResponse } from 'src/services/api/groups/types';

export const useGroups = () => {
    return useQuery(
        [queryKeys.groups],
        async () => {
            const res = await apiClient(GET_GROUPS_PATH).json<IGetGroupsResponse>();
            return res.groups;
        }
    );
};